import { useState, useEffect, useRef } from "react";
import styles from "../../../layout/admin/Main.module.scss";
import { Link } from "react-router-dom";
/*専用コンポーネント*/
import SearchForm from "./NotificationSearchFrom";
/*共通コンポーネント */
import ScreenTitle from "../../../layout/admin/ScreenTitle";
import SubScreenTitle from "../../../layout/admin/SubScreenTitle";
import DataTable from "../../../features/DataTable";
import Button from "../../../ui/Button";
import CSVDownloader from "../../../ui/CSVDownloader";
//API
import { getNoticeList } from "../../../../services/apiNotification";

//データテーブル項目
const tableMeata = [
  { key: "title", label: "件名" },
  { key: "created_at", label: "日付" },
  { key: "period_to", label: "掲載期間(To)" },
  { key: "content", label: "内容" },
];
const Notification = () => {
  // 検索条件
  const [searchCondition, setSearchCondition] = useState({});
  // 検索結果
  const [tableData, setTableData] = useState([]);
  const [tableSortData, setTableSortData] = useState([]);
  const tableResetRef = useRef();
  const [csvData, setCsvData] = useState({});

  //初回レンダリング
  useEffect(() => {
    setSearchCondition({}); //初期表示_条件なしで検索
  }, []); //初回レンダリング

  //検索条件更新
  useEffect(() => {
    (async function () {
      const data = await getNoticeList(searchCondition);
      if (!data) return;
      setTableData(
        data.map((d) => {
          return {
            key: d.id,
            title: <Link to={"./detail/" + d.id}>{d.title}</Link>,
            created_at: d.created_at,
            period_to: d.period_to,
            content: d.content,
          };
        })
      );
      setTableSortData(
        data.map((d) => {
          return {
            key: d.id,
            title: d.title,
            created_at: d.created_at,
            period_to: d.period_to,
            content: d.content,
          };
        })
      );
      setCsvData(
        data.map((d) => {
          return {
            件名: d.title,
            日付: d.created_at,
            "掲載期間(To)": d.period_to,
            内容: d.content,
          };
        })
      );
      //ページネーション・ソートをリセット
      tableResetRef.current?.click();
    })();
  }, [searchCondition]); //検索条件更新

  return (
    <div className={styles.main}>
      <ScreenTitle>お知らせ管理</ScreenTitle>
      <SubScreenTitle>お知らせ新規登録・カテゴリー管理</SubScreenTitle>
      <div className={styles.buttonbox__left}>
        <Link to={"./detail/new/0"}>
          <Button styleType="new">お知らせ新規登録</Button>
        </Link>
        <Link to={"./category"}>
          <Button styleType="new">カテゴリー管理</Button>
        </Link>
      </div>
      <SubScreenTitle>お知らせ検索</SubScreenTitle>
      <SearchForm setSearchCondition={setSearchCondition}></SearchForm>
      <DataTable
        tableData={tableData}
        tableMeata={tableMeata}
        tableSortData={tableSortData}
        tableResetRef={tableResetRef}
      ></DataTable>
      <CSVDownloader
        data={csvData}
        filenameprefix="お知らせ一覧"
        buttonname="ダウンロード"
      />
      <div className={styles.buttonbox}>
        <Link className={styles.link} to="/admin/top">
          トップページへ戻る
        </Link>
      </div>
    </div>
  );
};
export default Notification;
